import React from "react";
import Layout from "Layout";
import { Grid, makeStyles, Typography, Paper } from "@material-ui/core";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import { withRouter } from "react-router";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
}));

function Condition(props) {
  const { request } = useApi();
  const auth = useAuth();
  const [current, setCurrent] = React.useState(0);
  const [release, setRelease] = React.useState(0);
  const [maxWords, setMaxWords] = React.useState(0);
  const classes = useStyles();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 契約内容";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id)
  }, [props.location.pathname]);

  React.useEffect(() => {
    if (!auth.state.user.account_id) {
      return;
    }

    Promise.all([
      request({
        method: "POST",
        url: `config/:account_id/account`,
        data: {
          "attrs": [
            "max_words",
            "max_current",
            "release",
          ]        
        },
      }),
    ]).then(([filterhorse]) => {
      setMaxWords(filterhorse.data.max_words);
      setCurrent(filterhorse.data.max_current);
      setRelease(filterhorse.data.release);
    });
  }, [auth.state.user.account_id]);

  return (
    <Layout
      content={
        <Grid>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" color="primary">
              ご契約内容
            </Typography>

            <Grid container className={classes.wrapper} space={1}>
              <Typography>取得キーワード登録可能数：</Typography>
              <Typography>{maxWords}</Typography>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Typography>月間取得可能投稿件数：</Typography>
              <Typography>{current.toLocaleString()}</Typography>
            </Grid>
            <Grid container className={classes.wrapper}>
              <Typography>月間取得可能投稿件数の増量オプション：</Typography>
              <Typography>{release}回</Typography>
            </Grid>
          </Paper>
        </Grid>
      }
    />
  );
}
export default withRouter(Condition);
